import { render, staticRenderFns } from "./Welcome.vue?vue&type=template&id=9ffdb6e4&scoped=true"
import script from "./Welcome.vue?vue&type=script&lang=ts"
export * from "./Welcome.vue?vue&type=script&lang=ts"
import style0 from "./Welcome.vue?vue&type=style&index=0&id=9ffdb6e4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ffdb6e4",
  null
  
)

export default component.exports